import type { FC, ReactNode } from 'react';

import { PaymentMethodEnum } from '@/__generated_graphql__/graphql';
import { PaymentsCheckedIcon } from '@/components/ui/Icons/Icons';

import * as S from './Options.styles';

type CustomRadioProps = {
  label: ReactNode;
  name: string;
  value: PaymentMethodEnum;
  isChecked: boolean;
  disabled?: boolean;
  children?: ReactNode;
  onChange: (value: PaymentMethodEnum) => void;
};

export const CustomRadio: FC<CustomRadioProps> = ({
  label,
  name,
  value,
  isChecked,
  disabled,
  children,
  onChange,
  ...rest
}) => {
  const handleChange = () => {
    onChange(value);
  };

  return (
    <S.RadioLabel {...rest}>
      <S.HiddenRadioInput
        type="radio"
        name={name}
        value={value}
        checked={isChecked}
        disabled={disabled}
        onChange={handleChange}
      />
      <S.CustomRadioCircle
        $isChecked={isChecked}
        aria-checked={isChecked}
        aria-disabled={disabled}
      >
        <S.CheckmarkWrapper $isVisible={isChecked}>
          <PaymentsCheckedIcon />
        </S.CheckmarkWrapper>
      </S.CustomRadioCircle>
      <S.InlineText>{label}</S.InlineText>
      {children}
    </S.RadioLabel>
  );
};
